import { Easing, interpolate } from 'remotion';

// Constants
import { CLAMP_BOTH } from '@/constants';
import {
  SCENE5B_ANIMATION,
  SCENE5B_COLORS,
  SCENE5B_FONTS,
  SCENE5B_LAYOUT,
  SCENE5B_REVEAL_FRAME_RANGE,
} from '../../constants';

interface TrainingDateProps {
  dateLabel: string;
  frame: number;
}

export const TrainingDate = ({ dateLabel, frame }: TrainingDateProps) => {
  const { date } = SCENE5B_ANIMATION;

  // Ease-out cubic progress from 0 to 1 over the reveal frame range
  const progress = Easing.out(Easing.cubic)(
    interpolate(frame, SCENE5B_REVEAL_FRAME_RANGE, [0, 1], CLAMP_BOTH),
  );

  // Fade in following custom opacity stops
  const opacity = interpolate(
    progress,
    date.opacityStops,
    date.opacityValues,
    CLAMP_BOTH,
  );
  // Clip from right to left, revealing text progressively
  const clipRight = interpolate(progress, [0, 1], [100, 0], CLAMP_BOTH);

  return (
    <p
      className="absolute z-[3] whitespace-nowrap"
      style={{
        top: SCENE5B_LAYOUT.date.top,
        left: SCENE5B_LAYOUT.date.left,
        color: SCENE5B_COLORS.textDate,
        ...SCENE5B_FONTS.date,
        opacity, // Animated fade in
        clipPath: `inset(0% ${clipRight}% 0% 0%)`, // Wipe-reveal from left to right
      }}
    >
      {dateLabel}
    </p>
  );
};
